define(
	'Code25.CaterpartsGlobal.Cases', [
	'jQuery', 'underscore', 'Utils'
],
	function (
		jQuery, _, Utils
	) {
		'use strict';

		return {
			mount: function (container) {


				var layout = container.getComponent('Layout');

				if (layout) {


					if (SC.ENVIRONMENT.SCTouchpoint == "myaccount") {


						var Errors = require('Error');
						var CaseCreateView = require("Case.Create.View");
						if (CaseCreateView.CaseCreateView) {
							CaseCreateView = CaseCreateView.CaseCreateView;
						}


						CaseCreateView.prototype.getEvents = function () {
							return {
								'submit form': 'saveForm',
								'click [data-action="include_email"]': 'includeAnotherEmail',
								'keypress [data-action="text"]': 'preventEnter',
								'blur [name="title"]': 'onFormFieldChange',
								'blur [name="category"]': 'onFormFieldChange',
								'blur [name="message"]': 'onFormFieldChange',
								'blur [name="email"]': 'onFormFieldChange',
								'input [name="files"]': 'onFormFieldChange'
							};
						}


						CaseCreateView.prototype.getFormValues = function (
							$savingForm
						) {
							var formValues = $savingForm.serializeObject();
							var title = '';
							var category = '';
							var message = '';
							var email = '';
							
							var files = [];
							var includeEmail = false;
							var errorsResult = {
								errorCode: Errors.FormValidation,
								errors: {}
							};
							if ('title' in formValues && typeof formValues.title === 'string' && formValues.title) {
								title = formValues.title;
							} else {
								errorsResult.errors.title = Utils.translate('Subject is required');
							}
							if (
								'category' in formValues &&
								typeof formValues.category === 'string' &&
								formValues.category
							) {
								category = formValues.category;
							}
							if (
								'message' in formValues &&
								typeof formValues.message === 'string' &&
								formValues.message
							) {
								message = formValues.message;
							} else {
								errorsResult.errors.message = Utils.translate('message is required');
							}
							message+="\r\n";
							
							
							if (
								this.files && this.files.length > 0
							) {
								files = this.files;

								message += "\r\n";
								for (var i = 0; i < files.length; i++) {
									message += (i + 1) + ". 📁 " + files[i].name + "\r\n";
								}

							}
							if (
								'include_email' in formValues &&
								typeof formValues.include_email === 'string' &&
								formValues.include_email === 'on'
							) {
								includeEmail = true;
								if ('email' in formValues && typeof formValues.email === 'string' && formValues.email) {
									email = formValues.email;
								} else {
									errorsResult.errors.email = Utils.translate('Please provide a valid email');
								}
							}
							if (title && category && message) {
								var result = {
									title: title,
									category: category,
									message: message,
									files: files
								};
								if (includeEmail) {
									result.email = email;
								}
								return result;
							}
							return errorsResult;
						}

						CaseCreateView.prototype.addFile = function (file) {
							if (file) {
								var reader = new FileReader();
								var self = this;
								reader.onloadend = function () {


									var b64 = reader.result.replace(/^data:.+;base64,/, '');

									self.files.push({ name: file.name, data: b64 });
									console.log(self.files);
								};

								reader.readAsDataURL(file);
							}
						}

						CaseCreateView.prototype.getFormFieldValue = function (changedInput) {
							var newVal = changedInput.val();
							var fieldName = changedInput.attr('name');
							
							if (fieldName === 'title' && typeof newVal === 'string') {
								return {
									name: fieldName,
									value: newVal
								};
							}
							if (fieldName === 'email' && typeof newVal === 'string') {
								return {
									name: fieldName,
									value: newVal
								};
							}
							if (fieldName === 'message' && typeof newVal === 'string') {
								return {
									name: fieldName,
									value: newVal
								};
							}
							if (fieldName === 'category' && typeof newVal === 'string') {
								return {
									name: fieldName,
									value: newVal
								};
							}
							
							if (fieldName === 'files') {//&& typeof newVal === 'string'
								this.files = [];
								for (var i = 0; i < changedInput[0].files.length; i++) {
									this.addFile(changedInput[0].files[i]);
								}
								return {
									name: fieldName,
									value: newVal
								};
							}

							return {
								name: fieldName || '',
								error: Utils.translate("Please provide a valid "+fieldName)
							};
						}

						CaseCreateView.prototype.getContext = function () {
							
							return {
								pageHeader: this.pageHeader,
								categories: this.fields.get('categories'),
								showBackToAccount:
									this.options.application.getConfig().siteSettings.sitetype === 'STANDARD'
							};
						}


						var CaseDetailView = require("Case.Detail.View");
						if (CaseDetailView.CaseDetailView) {
							CaseDetailView = CaseDetailView.CaseDetailView;
						}

						CaseDetailView.prototype.getEvents = function () {
							return {
								'submit form': 'saveForm',
								'click [data-action="reset"]': 'resetForm',
								'click [data-action="close-case"]': 'closeCase',
								'blur [name="reply"]': 'onFormFieldChange',
								'input [name="files"]': 'onFormFieldChange'
							};
						}

						CaseDetailView.prototype.getFormValues = function (
							$savingForm
						) {
							var formValues = $savingForm.serializeObject();
							var reply = '';
							var files = [];
							var errorsResult = {
								errorCode: Errors.FormValidation,
								errors: {}
							};

							if ('reply' in formValues && typeof formValues.reply === 'string' && formValues.reply) {
								reply = formValues.reply;
							} else {
								errorsResult.errors.reply = Utils.translate('reply is required');
							}

							if (
								this.files && this.files.length > 0
							) {
								files = this.files;

								reply += "\r\n\r\n";
								for (var i = 0; i < files.length; i++) {
									reply += (i + 1) + ". 📁 " + files[i].name + "\r\n";
								}

							}

							if (reply) {
								return {
									reply: reply,
									files: files
								};
							}

							return errorsResult;
						}

						CaseDetailView.prototype.addFile = function (file) {
							if (file) {
								var reader = new FileReader();
								var self = this;
								reader.onloadend = function () {


									var b64 = reader.result.replace(/^data:.+;base64,/, '');

									self.files.push({ name: file.name, data: b64 });
									console.log(self.files);
								};

								reader.readAsDataURL(file);
							}
						}

						CaseDetailView.prototype.getFormFieldValue = function (changedInput) {
							var newVal = changedInput.val();
							var fieldName = changedInput.attr('name');

							if (fieldName === 'reply' && typeof newVal === 'string') {
								return {
									name: fieldName,
									value: newVal
								};
							}

							if (fieldName === 'files') {//&& typeof newVal === 'string'
								this.files = [];
								for (var i = 0; i < changedInput[0].files.length; i++) {
									this.addFile(changedInput[0].files[i]);
								}
								return {
									name: fieldName,
									value: newVal
								};
							}

							return {
								name: fieldName || '',
								error: Utils.translate("Please provide a valid "+fieldName)
							};
						}


					}


				}

			}
		}
	}
);
